import React, { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import classnames from 'classnames/bind';
import { meeting } from '@/models';
import Whiteboard from '@/components/Whiteboard';
import { AppProvider, AppShape, LOCALE } from '@/utils/appProvider';
import Style from './index.less';
import { setLocale } from '@/utils/locale';

const $c = classnames.bind(Style);

const PadWhiteboard: React.FC = () => {
  const location = useLocation();

  const [ready, setReady] = useState(false);

  const context: AppShape = useMemo(() => {
    return {
      locale: LOCALE.CN,
      prefixCls: 'popo-meeting',
      getPrefixCls: ((prefix: string) => (suffix: string, prefixCls?: string) => {
        if (!prefixCls) {
          prefixCls = suffix ? `${prefix}-${suffix}` : prefix;
        }
        return prefixCls;
      })('popo-meeting'),
    };
  }, []);

  const query = useMemo(() => {
    // 示例链接：https://localhost:7788/meet/mobile/whiteboard?channelId=1344376309467117&appkey=924af0ee72dae9709ae339daf6c5ed82&nonce=B37F0BE1213240B5825D7D35B9DC7BA3&curTime=1638084134&checksum=1fc87f97b061a5bd6365e020e8bb76aa038f2887&whiteboardOwner=4y@corp.netease.com&uid=4y@corp.netease.com&yxuid=443072&uname=4y@corp.netease.com
    const search = new URLSearchParams(location.search);
    const result = {
      channelId: search.has('channelId') ? Number.parseInt(search.get('channelId') || '0', 10) : 0,
      appkey: search.get('appkey')!,
      nonce: search.get('nonce')!,
      curTime: search.get('curTime')!,
      checksum: search.get('checksum')!,
      whiteboardUid: search.get('whiteboardOwner') || '',
      uid: search.get('uid') || '',
      yxuid: search.get('yxuid') || search.get('yxUid') || '',
      uname: search.get('uname') || '',
      title: search.get('title') || '',
      whiteboardChannelId: search.get('whiteboardChannelId') || '',
      locale: search.get('locale') || '',
    };
    console.log('mobileWhiteboard query', result);

    return result;
  }, [location.search]);

  useEffect(() => {
    // TODO: 从客户端获取 locale
    // 不能通过刷新页面来更新国际化，刷新页面的时候会导致白板的请求中断
    // 所以改为不刷新更新国际化，但是要等白板的内容渲染才设置语言，否则白板内的文案不会被更新
    setTimeout(() => {
      setLocale(query.locale === '' ? 'zh-CN' : query.locale, false);
    }, 0);
  }, []);

  useEffect(() => {
    document.title = query.title || '白板';
    setReady(true);
  }, [query]);

  if (
    !query.whiteboardChannelId ||
    !query.appkey ||
    !query.nonce ||
    !query.curTime ||
    !query.checksum ||
    !query.whiteboardUid ||
    !query.uid ||
    !query.yxuid ||
    !query.uname
  ) {
    const imptyKeys = Object.keys(query).filter((n) => !query[n]);
    console.error('缺少必要参数', imptyKeys);
    return null;
  }

  if (!ready) {
    return (
      <div className={$c('pad-whiteboard', 'loading')}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <AppProvider value={context}>
      <div className={$c('pad-whiteboard')}>
        <Whiteboard {...query} willClose={meeting!.whiteboardWillClose} />
      </div>
    </AppProvider>
  );
};

export default PadWhiteboard;
